module.exports = __webpack_public_path__ + "img/adobe-commerce-vs-magento.5a4f4480.webp";